import React, { useEffect, useState } from "react";
import DefaultModal from 'Components/Modal/DefaultModal';
import { Input, Table } from "reactstrap";
import axiosInstance from "Api";
import PopupBasic from "Components/Popup/BasicPopup";
import { BiLock } from "react-icons/bi";
import { useAvailabilityContext } from "./context/AvailabilityContext";
import { useUncheckCommunity } from "Api/Coordinator/Gebruikers";

const CommunityTypesModal = ({ text, iAdminId = "" }) => {
    const [request, setRequest] = useState({
        shouldFetch: false,
        communityId: null,
        type: null,
    });

    const { data } = useUncheckCommunity(
        request.communityId,
        request.type,
        iAdminId,
        request.shouldFetch
    );

    const {
        openInstitutions,
        setOpenInstitutions,
        communities,
        setShowUncheckModal,
        setType,
        checkedCommunities,
        setCheckedCommunities,
        setCommunityToUncheck
    } = useAvailabilityContext();

    const handleCheckCommunity = (commId, commType) => {
        setRequest({
            shouldFetch: true,
            communityId: commId,
            type: commType,
        });
    };

    useEffect(() => {
        if (!data) return;

        if (data.status === "success") {
            setType(request.communityId + request.type);
        }

        setOpenInstitutions(false);

        setRequest(prev => ({
            ...prev,
            shouldFetch: false,
        }));
    }, [data]);

    return (
        <DefaultModal
            modal={openInstitutions}
            headerTitle={"Instellingen"}
            toggle={() => setOpenInstitutions(false)}
            showFooterBtns={false}
            classes="modal-dialog__over feedback-modal-style availability-modal wc-500"
        >
            <p>{text}</p>

            <Table borderless className="mb-0">
                <tbody>
                    {
                        communities.length && communities.map((comm, id) =>
                            <tr key={id}>
                                <th className="col-1">{comm.name}</th>
                                <td className="popup-parent">

                                    {comm.type !== "S" && comm.locked != 0 ?
                                        <>
                                            <PopupBasic
                                                name={
                                                    <Input
                                                        id={`popup-${id}`}
                                                        type="checkbox"
                                                        name={comm.name}
                                                        value={comm.type}
                                                        disabled={true}
                                                        checked={true}
                                                    />
                                                }
                                                content={
                                                    <div className="d-flex justify-content-between align-items-center gap-3">
                                                        <BiLock fontSize={"50px"} />
                                                        <p>
                                                            Sommige dagdelen zijn geblokkeerd, wilt u de beschikbaarheid wijzigen neem dan contact op met de des betreffende coördinator
                                                        </p>
                                                    </div>
                                                }
                                            />
                                        </>
                                        :
                                        <Input
                                            type="checkbox"
                                            name={comm.name}
                                            value={comm.type}
                                            checked={checkedCommunities?.includes(comm.id)}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    //community selected
                                                    setCheckedCommunities(prev => [...prev, comm.id]);
                                                    handleCheckCommunity(comm.id, "A");
                                                } else {
                                                    //unselecting a community
                                                    setCheckedCommunities(prev =>
                                                        prev.filter(id => id !== comm.id)
                                                    );
                                                    setCommunityToUncheck(comm);
                                                    setOpenInstitutions(false);
                                                    setShowUncheckModal(true);
                                                }
                                            }}
                                        />
                                    }
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </Table>
        </DefaultModal>
    )
}

export default CommunityTypesModal;
